import gql from 'graphql-tag';

export default gql`
  mutation invitationAcceptAsNewBuyer($input: InvitationAsNewBuyerInput!) {
    invitationAcceptAsNewBuyer(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
